import React from 'react';

import { IconType } from 'react-icons/lib';

import { Container, ContainerWhite } from './styles';




const PoliticaDePrivacidade: React.FC = () => {



  return (
    <>
      <ContainerWhite id="cancelamento">
        
         <div className="p50 p600" style={{ textAlign: 'justify' }}>
          <h2> AVISO DE PRIVACIDADE</h2>
          <br />
          <br />
          A FundMed preza pela transparência com o titular de dados pessoais e apresenta este
documento para acessibilizar o conhecimento ao titular sobre as informações coletadas e
tratadas através da Plataforma de Eventos FundMed. Fique tranquilo: a FundMed possui
um Programa de Gestão da Privacidade e busca garantir a conformidade com a Lei Geral
de Proteção de Dados Pessoais - LGPD (Lei no 13.709/2018) e demais resoluções da
Autoridade Nacional de Proteção de Dados (ANPD) em todos os seus processos de
negócio.
<br/><br/>
Na Plataforma de Eventos, serão coletados dados como nome completo, e-mail, CPF,
telefone, profissão e estado/cidade. A depender do evento e seu contexto, ainda poderão
ser solicitados dados adicionais, como data de nascimento, comprovante de matrícula e
especificações sobre sua profissão.
<br/><br/>
Seus dados pessoais serão mantidos pelo período de 05 (cinco) anos, para promover o
suporte adequado ao evento e tudo que decorrer deste, como por exemplo, temas
relacionados a pagamento, reembolso e pesquisas de satisfação. Com a finalidade de
oferecer o suporte adequado relacionado ao evento, compartilharemos apenas os dados
pessoais estritamente necessários com a Encontro Digital (para gestão dos meios de
pagamento) e com a equipe organizadora do evento.
<br/><br/>
Se você optar por receber comunicações sobre a FundMed, será inscrito em nossa
Newsletter, que oferece uma curadoria semanal de notícias relacionada a área da saúde.
Neste caso, apenas seu nome, e-mail e profissão serão mantidos em nossa base de dados.
Caso queira cancelar sua inscrição, é possível através do formulário de Contato no site
institucional, com o assunto “Requisitar descadastramento da Newsletter”.
<br/><br/>
<strong>No dia do evento:</strong>
<br/> 
Durante nossos eventos, realizamos cobertura fotográfica e audiovisual, diretamente ou por
meio de fornecedores contratados ou de patrocinadores. Esse material pode ser utilizado
para registro institucional, cumprimento de obrigações legais e contratuais, bem como para
divulgação das atividades da FundMed em nossos canais oficiais.
Esclarecemos que, caso haja interesse em utilizar sua imagem de forma individualizada
para fins promocionais ou destacados, solicitaremos previamente a devida autorização, em
conformidade com a LGPD.
Os patrocinadores, por sua vez, poderão utilizar as imagens captadas no evento para fins
comerciais, desde que observados os direitos de imagem, a legislação aplicável e eventuais
limites definidos pela FundMed.
Caso você tenha dúvidas sobre o tratamento de seus dados pessoais, entre em contato
conosco através do e-mail compliance@fundmed.org.br. Para dúvidas relacionadas ao
evento, entre em contato conosco através do e-mail eventos@fundmed.org.br.<br/><br/>

Rua São Manoel, 638 - Porto Alegre -
<br/>
 Rua Ramiro Barcelos, 2350 - sala 177 - Porto Alegre - RS

   </div>
      </ContainerWhite>
    </>
  );
};
export default PoliticaDePrivacidade;
